import { getCardTypeLabel } from 'modules/expenses/lib/cards/getCardTypeLabel'
import { CARD_TYPE } from 'modules/expenses/lib/types'

export const transactionTypeWithCard = (
  card:
    | {
        cardType?: CARD_TYPE
        last4?: string | null
      }
    | undefined
    | null
) => {
  if (!card) {
    return ''
  }
  const { cardType, last4 } = card

  if (!cardType || !last4) {
    return ''
  }
  return `${getCardTypeLabel(cardType)} *${last4}`
}
